import React from 'react'
import { Stack } from '@mui/material'

import { SPACING } from '../../typography'
import { FactionStack } from './stacks'
import { HeaderSecondary } from '../../typography'
import { ImageBlock } from '../../image-block'

export const FactionItem = props => {
  const { children = null, color = '', name = '', image = '', backgroundColor} = props
  return (
    <>
      {image && <ImageBlock image={image} backgroundColor={backgroundColor} />}
      <Stack spacing={SPACING} sx={{ color }}>
        <HeaderSecondary>{name}</HeaderSecondary>
        <FactionStack {...props} />
      </Stack>
      {children}
    </>
  )
}
